
const VIEW_MODE = {
  BASIC: "Advanced", //These are switched because it is used in the display mode
  ADVANCED: "Basic"
};


export default (VIEW_MODE);
